module.exports = __webpack_public_path__ + "img/grades.ab8f85ce.png";